import React, { createContext, useEffect } from "react";
import { useSnapshot } from "@web-monorepo/hooks";
import { useSessionQuery } from "#/src/hooks/useSession";
import { useMarketplaceTutorRealtime } from "#/src/hooks/useMarketplaceTutorRealtime";
import { tutorRealtimeStore } from "./tutorRealtimeStore";

const TutorRealtimeContext = createContext<typeof tutorRealtimeStore | undefined>(undefined);

export function TutorRealtimeProvider({ children }: { children: React.ReactNode }) {
  const { sessionData } = useSessionQuery();
  const tutorId = sessionData?.user_details.uid;
  const snap = useSnapshot(tutorRealtimeStore);

  useEffect(() => {
    if (!tutorId) {
      return;
    }
    // Only tear down + re-init when the *identity* of the connection changes
    // (a different tutor). `setParams` merges, so light-touch updates don't
    // abort an in-flight connection.
    const params = tutorRealtimeStore.params;
    const connectionIdentityChanged = params == null || params.tutorId !== tutorId;

    if (connectionIdentityChanged) {
      tutorRealtimeStore.disconnect();
    }
    tutorRealtimeStore.setParams({ tutorId });
  }, [tutorId]);

  // Subscribe to NATS messages only while the tutor is actively connected for
  // SNTS. The hook tears down cleanly when `enabled` flips to false (e.g. on
  // disconnect()).
  useMarketplaceTutorRealtime({
    tutorId,
    enabled: snap.status._tag === "connected",
  });

  return <TutorRealtimeContext.Provider value={tutorRealtimeStore}>{children}</TutorRealtimeContext.Provider>;
}
